import Axios from "axios";
import { ApiClient } from "../api/api-client";
import { RegistrationStore } from "./registration-store";


export class AgentRootStore{
    apiclient= new ApiClient(Axios);
    registrationStore=new RegistrationStore(this.apiclient);
}
